//nwe are going to have courselessons and videocourselessons as index pages for loading correct components based on courseSlug's
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { courseRegistry } from "../../courses/courseRegistry";
import VideosHome from "../Content/VideosHome/VideosHome";
import LecturesHome from "../ContentHtml/LecturesHome/LecturesHome";
import {slugify} from "../../utils/slugify";
import Home from "../Home/Home";

export default function CourseLessons(props) {
  const { courseSlug, lessonSlug, lectureSlug } = useParams();
  const navigate = useNavigate();
  
  const courseConfig = courseRegistry[courseSlug];
  const activeSlug = lectureSlug || lessonSlug;

    //adding redirect to 1st lecture
  useEffect(() => {
    if (!courseConfig) return;
    if (activeSlug) return;

    //lecture-type, course > redirecting
    if(courseConfig.contentType === "lecture") {
      const firstLecture = 
        courseConfig.levelContentData
          ?.flatMap(level => level.subjects || [])
          ?.flatMap(subject => subject.lectures || [])[0];

        if (firstLecture) {
          navigate(
            `/course/${courseSlug}/lectures/${slugify(firstLecture.key || firstLecture.title || firstLecture)}`,
            { replace: true}
          );
        }
        return;
    }

    //video-type courses > redirect 1st video
    const firstLevelWithVideos = courseConfig.levelContentData.find(
      level => Array.isArray(level.videos) && level.videos.length > 0
    );
    const firstLesson = firstLevelWithVideos?.videos?.[0]?.list?.[0];
  
    if(firstLesson) {
      navigate(`/course/${courseSlug}/lessons/${slugify(firstLesson)}`, {replace: true});
    }
  }, [activeSlug, courseSlug, courseConfig, navigate]);

  if(!courseConfig) return <Home />;
  if(courseConfig.contentType === "lecture") {
    return <LecturesHome {...props} />
  }
  
  return <VideosHome {...props}/>

}
//not using for now  I decided to have lectures and videos visibly separated for preventing confusin 